import { render, staticRenderFns } from "./BannerInfo.vue?vue&type=template&id=402a2c20&scoped=true&"
import script from "./BannerInfo.vue?vue&type=script&lang=js&"
export * from "./BannerInfo.vue?vue&type=script&lang=js&"
import style0 from "./BannerInfo.vue?vue&type=style&index=0&id=402a2c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a2c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402a2c20')) {
      api.createRecord('402a2c20', component.options)
    } else {
      api.reload('402a2c20', component.options)
    }
    module.hot.accept("./BannerInfo.vue?vue&type=template&id=402a2c20&scoped=true&", function () {
      api.rerender('402a2c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/BannerInfo.vue"
export default component.exports